import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Education = () => {
    return (
        <div>
            <Navbar />

            <div className="hero-section">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">Educational Resources</h1>
                <p className="text-base sm:text-lg md:text-xl text-gray-200">Access learning materials in sign language</p>
            </div>

            <div className="section">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#003366] mb-6">Welcome to our library</h2>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                    Discover a growing collection of learning and resource materials in sign language. Our digital library is designed
                    to support both Deaf learners and Hearing learners. Aside from the sign language integration, learning materials have
                    voice overlay, making them accessible for all. Browse step-by-step video tutorials, downloadable worksheets, and classroom-friendly
                    activities that you can use anytime, anywhere.
                </p>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                    Browse step-by-step video tutorials, downloadable worksheets, and classroom-friendly activities
                    that you can use anytime, anywhere.
                </p>
                <ul className="list-disc list-inside text-base sm:text-lg text-gray-700 space-y-1">
                    <li>Beginner to advanced sign language lessons</li>
                    <li>Resources for teachers, parents, and interpreters</li>
                    <li>Content that supports inclusive classrooms and workplaces</li>
                </ul>
            </div>

            <div className="section">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#003366] mb-6">Welcome to our sign language center</h2>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                    Our sign language center is a safe and welcoming space where deaf, hard of hearing, and hearing
                    learners come together. Whether you are just starting or looking to improve your fluency, you will
                    find programs that match your goals.
                </p>
                <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                    Learn at your own pace with practical, real-life scenarios that help you communicate clearly at
                    school, work, and in your community.
                </p>
                <ul className="list-disc list-inside text-base sm:text-lg text-gray-700 space-y-1">
                    <li>Beginner, intermediate, and advanced learning paths</li>
                    <li>Support for educators, interpreters, and inclusive institutions</li>
                    <li>Guidance on deaf culture, etiquette, and respectful communication</li>
                </ul>
            </div>

            <div className="section">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#003366] mb-6">Tips for Learning Sign Language</h2>
                <div className="flex flex-col gap-4">
                    <div className="card">
                        <h3 className="text-lg sm:text-xl font-semibold text-[#0066cc] mb-2">1. Practice Regularly</h3>
                        <p className="text-gray-700 text-sm sm:text-base">
                            Consistency is key. Set aside time each day to practice signs and review what you have learned.
                        </p>
                    </div>

                    <div className="card">
                        <h3 className="text-lg sm:text-xl font-semibold text-[#0066cc] mb-2">2. Engage with the Community</h3>
                        <p className="text-gray-700 text-sm sm:text-base">
                            Join local deaf community events or online forums to practice your skills with native signers.
                        </p>
                    </div>

                    <div className="card">
                        <h3 className="text-lg sm:text-xl font-semibold text-[#0066cc] mb-2">3. Use Visual Learning Aids</h3>
                        <p className="text-gray-700 text-sm sm:text-base">
                            Watch videos, use flashcards, and observe how signs are formed to improve your understanding.
                        </p>
                    </div>

                    <div className="card">
                        <h3 className="text-lg sm:text-xl font-semibold text-[#0066cc] mb-2">4. Be Patient and Respectful</h3>
                        <p className="text-gray-700 text-sm sm:text-base">
                            Learning a new language takes time. Be patient with yourself and always approach communication with respect.
                        </p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Education;
